export default {
  API: ["CANCEL", "SAVE"],
  DB: ["TEST", "CANCEL", "SAVE"],
  SAAS: ["CANCEL", "SAVE_AND_AUTHORIZE"],
  REMOTE: ["CANCEL", "SAVE"],
};
